var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 10,
    viewBox: "0 0 40 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3457 9515)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -18)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    transform: "translate(-3457 -9497)",
    fill: "#36c9e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5624.538,4042.4a6,6,0,1,1-12,0Z",
    transform: "translate(-9047.537 -13529.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -526)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9.6,
    transform: "translate(-3457 -8971)",
    fill: "#1a1a64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 9.6,
    transform: "translate(-3451 -8971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4,
    transform: "translate(-3457 -8968.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.6V8.5L14.714,0H16V1.106L1.285,9.6Z",
    transform: "translate(-3457 -8971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.715,9.6,0,1.105V0H1.287L16,8.495V9.6Z",
    transform: "translate(-3457 -8971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 9.6,
    transform: "translate(-3450 -8971)",
    fill: "#ed5200"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 16,
    transform: "translate(-3441 -8967.2) rotate(90)",
    fill: "#ed5200"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    transform: "translate(-3435 -9489)",
    fill: "#ed5200"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-3541.218-8606h-5.49l-14.51,24h20Z",
    transform: "translate(124.218 -909)",
    opacity: 0.095
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiji);
export default __webpack_public_path__ + "static/media/FIJI.c72bad1c9e84012d9ad5aa27dd5557e1.svg";
export { ForwardRef as ReactComponent };